import Script from 'next/script'

type CartPageScriptProps = {
	basket_items: Record<string, number>
}

export const CartPageScript = (props: CartPageScriptProps) => {
	const { basket_items } = props
	const xcnt_basket_products = Object.keys(basket_items).join(',')
	const xcnt_basket_quantity = Object.values(basket_items).join(',')

	return (
		<Script id="xcntmyAsync" strategy="lazyOnload">
			{`var xcnt_basket_products = '${xcnt_basket_products}';
var xcnt_basket_quantity = '${xcnt_basket_quantity}';
(function(d){ var xscr = d.createElement( 'script' ); xscr.async = 1; xscr.src =
'//x.cnt.my/async/track/?r=' + Math.random(); var x = d.getElementById( 'xcntmyAsync' );
x.parentNode.insertBefore( xscr, x ); })(document);`}
		</Script>
	)
}
